import React, { useCallback } from 'react';

import { trackEvent } from 'src/lib/analytics';

import CreateIncident from './CreateIncident';
import CreateIssue from './CreateIssue';
import ReactOnIncidentStatusChange from './ReactOnIncidentStatusChange';
import ReactOnJiraStatusChange from './ReactOnJiraStatusChange';
import Scope from './Scope';
import SyncComments from './SyncComments';

const getConfigCheckboxName = (checkboxname) => {
  if (checkboxname && typeof checkboxname === 'string') {
    const [name] = checkboxname.split('.').reverse();
    if (['sync_comments', 'autocreate_incidents', 'autocreate_issues', 'react_on_incident_event', 'react_on_issue_status_change'].includes(name)) {
      return 'settings_rules_' + `${name}`;
    }
  }
  return null;
};

const getConfigCheckboxValue = (value) => {
  if (value) {
    return 'enable';
  } else return 'disable';
};

const Config = ({ name, values = {}, errors = {}, touched = {}, onChange, onBlur }) => {
  const onChangeWithTracking = useCallback(({ target }) => {
    if (target.type === 'checkbox') {
      const eventname = getConfigCheckboxName(target.name);
      if (eventname) {
        trackEvent(eventname, { action: getConfigCheckboxValue(target.checked) });
      }
    }
    onChange({ target });
  }, [onChange]);

  const props = {
    name: `${name}.config`,
    values: values.config,
    errors: errors.config,
    touched: touched.config,
    onChange: onChangeWithTracking,
    onBlur
  };

  return (
    <div>
      <Scope {...props}/>
      <SyncComments {...props}/>
      <CreateIncident {...props}/>
      <CreateIssue {...props}/>
      <ReactOnIncidentStatusChange {...props}/>
      <ReactOnJiraStatusChange {...props}/>
    </div>
  );
};

export default Config;
